import { __extends, __spreadArray } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { Trans } from 'react-i18next';
import TextTooltipOnHover from '../Popover/Preset/TextTooltipOnHover';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { withMobileContext, } from '@wix/da-react-context/pkg/MobileContext';
import s from './ProfileStatItems.scss';
function placeCommasInNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
var ProfileStatItems = /** @class */ (function (_super) {
    __extends(ProfileStatItems, _super);
    function ProfileStatItems() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProfileStatItems.prototype.render = function () {
        var _a = this.props, defaultStats = _a.defaultStats, additionalStats = _a.additionalStats, itemClassName = _a.itemClassName, statsData = _a.statsData, isMobile = _a.isMobile;
        var stats = __spreadArray(__spreadArray([], defaultStats, true), additionalStats, true);
        return stats.map(function (stat) {
            var statValue = statsData[stat] || 0;
            var formattedCount = shortenNumber(statValue);
            var isTooltipNeeded = Number(formattedCount) !== statValue;
            return (React.createElement("span", { key: stat, className: classnames(s['item'], itemClassName) },
                React.createElement(Trans, { i18nKey: "profileStats.".concat(stat), count: statValue },
                    !isMobile && isTooltipNeeded ? (React.createElement(TextTooltipOnHover, { key: stat, tooltipText: placeCommasInNumber(statValue), className: s['tooltip-wrap'] }, formattedCount)) : (React.createElement("span", null, formattedCount)),
                    "\u00A0",
                    stat)));
        });
    };
    return ProfileStatItems;
}(React.Component));
export { ProfileStatItems };
var enhance = compose(withMobileContext);
export default enhance(ProfileStatItems);
//# sourceMappingURL=ProfileStatItems.js.map